import React from "react";

const flags: Record<string, React.FC<{ className?: string }>> = {
  en: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#012169" d="M0 0h640v480H0z"/>
      <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z"/>
      <path fill="#C8102E" d="m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z"/>
      <path fill="#FFF" d="M241 0v480h160V0zM0 160v160h640V160z"/>
      <path fill="#C8102E" d="M0 193v96h640v-96zM273 0v480h96V0z"/>
    </svg>
  ),
  fr: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#002395" d="M0 0h213.3v480H0z"/>
      <path fill="#FFF" d="M213.3 0h213.4v480H213.3z"/>
      <path fill="#ED2939" d="M426.7 0H640v480H426.7z"/>
    </svg>
  ),
  de: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#000" d="M0 0h640v160H0z"/>
      <path fill="#D00" d="M0 160h640v160H0z"/>
      <path fill="#FFCE00" d="M0 320h640v160H0z"/>
    </svg>
  ),
  it: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#009246" d="M0 0h213.3v480H0z"/>
      <path fill="#FFF" d="M213.3 0h213.4v480H213.3z"/>
      <path fill="#CE2B37" d="M426.7 0H640v480H426.7z"/>
    </svg>
  ),
  pt: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#006600" d="M0 0h240v480H0z"/>
      <path fill="#FF0000" d="M240 0h400v480H240z"/>
      <circle cx="240" cy="240" r="64" fill="#FFCC00" stroke="#006600" strokeWidth="4"/>
    </svg>
  ),
  es: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#AA151B" d="M0 0h640v480H0z"/>
      <path fill="#F1BF00" d="M0 120h640v240H0z"/>
    </svg>
  ),
};

interface FlagIconProps {
  code: string;
  className?: string;
}

const FlagIcon: React.FC<FlagIconProps> = ({ code, className = "w-5 h-4" }) => {
  const Flag = flags[code];
  if (!Flag) return null;
  return <Flag className={`${className} rounded-[2px] inline-block overflow-hidden`} />;
};

export default FlagIcon;
